import { FunctionComponent } from 'react';
import { Box, Flex, GmgTheme } from '@gmg/gmg-react-components';
import styled, { useTheme } from 'styled-components';
import { Trans, useTranslation } from 'react-i18next';
import PictoInviteErrorDark from '../../../assets/svg/graphic_invite-error-dark-255.svg';
import PictoInviteErrorLight from '../../../assets/svg/graphic_invite-error-light-255.svg';

const InviteExpired: FunctionComponent<{}> = () => {
    const { t } = useTranslation();
    const theme: GmgTheme = useTheme();

    return (
        <Flex height="100%" bg="backgroundPaper" justifyContent="center">
            <Div>
                {theme.type === 'dark'
                    ? <PictoInviteErrorDark width={255} height={255} />
                    : <PictoInviteErrorLight width={255} height={255} />
                }
                <h1>{t('ErrorMsg.invitationExpired', 'The invitation to the organization does not exist anymore.')}</h1>
                <Box className="px14_400_contrast" pt="24px">
                    <Trans t={t} i18nKey={'ErrorMsg.supportInvite'}>
                        Please contact your organization admin to get a new invitation link or&nbsp;
                        <a
                            href="https://gmgcolor.com/support"
                            target="_blank"
                            rel="noreferrer"
                        >
                            GMG support.
                        </a>
                    </Trans>
                </Box>
            </Div>
        </Flex>
    );
};

const Div = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  max-width: 480px;
  text-align: center;
  line-height: 1.4;
`;


export default InviteExpired;
